import { render, staticRenderFns } from "./CustomPagination.vue?vue&type=template&id=3a577510&scoped=true"
import script from "./CustomPagination.vue?vue&type=script&lang=ts"
export * from "./CustomPagination.vue?vue&type=script&lang=ts"
import style0 from "./CustomPagination.vue?vue&type=style&index=0&id=3a577510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a577510",
  null
  
)

export default component.exports